<template>
  <div class="cases-container-lazyload cases">
    <div ref="scrollPanel" class="scroll-content" v-on="eventBinding">
      <div class="case-content" v-for="(item, key) in currentDataSet" :key="key" :style="cardContentStyle">
        <card :attributes="item" />
      </div>
      <div class="logo-container-case-card-container" v-if="onLazyLoading">
        <st-loading-logo></st-loading-logo>
      </div>
    </div>
  </div>
</template>

<script>
import card from './../cases/case-card.vue'
import StLoadingLogo from './StLoadingLogo.vue'
import TouchScroll from './TouchScroll'
import {frameRateLimited} from './../../../../plugins/util'

import {mapState} from 'vuex'
import _reverse from 'lodash/reverse'

export default {
  props: ['attributes'],
  components: {card, StLoadingLogo},
  data () {
    return {
      dataset: [],
      enableLazyLoad: this.attributes.value.lazyload && this.attributes.value.lazyload === 'true',
      slideCount: (this.attributes.value.mincase && parseInt(this.attributes.value.mincase)) || 4,
      onLazyLoading: false
    }
  },
  mounted () {
    new TouchScroll(this.$refs.scrollPanel, {
      draggable: true,
      wait: false
    })
  },
  watch: {
    onLazyLoading () {
      if (this.onLazyLoading) {
        this.$nextTick(() => {
          this.$refs.scrollPanel.scrollLeft = this.$refs.scrollPanel.scrollWidth
        })
      }
    },
    'jsonkeydata': function (newVal, oldVal) {
      if (!newVal) return
      if (this.attributes.value.group === 'date-confirmed') {
        if (this.attributes.value.order && this.attributes.value.order === 'ascending') {
          this.dataset = _reverse(newVal)
        } else {
          this.dataset = newVal
        }
      }
    },
    'variabledata': function (newVal, oldVal) {
      if (!newVal) return
      var dataset = []
      if (this.attributes.value.group === 'new-cases') {
        dataset = newVal.newcases
      } else if (this.attributes.value.group === 'died') {
        dataset = newVal.died
      }
      if (this.attributes.value.order === 'ascending') {
        dataset = _reverse(dataset)
      }
      if (dataset.length) {
        this.dataset = dataset
      }
    }
  },
  computed: {
    ...mapState(['jsonkeydata', 'variabledata']),
    filterDataset () {
      if (this.attributes.value.group === 'date-confirmed') {
        return this.dataset.filter(d => !d['28-days-passed'])
      }
      return this.dataset
    },
    currentDataSet () {
      if (this.enableLazyLoad) {
        return this.filterDataset.filter((d, i) => i < this.slideCount)
      }
      return this.filterDataset
    },
    eventBinding () {
      return this.enableLazyLoad ? {scroll: frameRateLimited(this.onScroll)} : null
    },
    targetColumn () {
      if (this.$window.innerWidth < 500) return 1
      if (this.$window.innerWidth < 900) return 2
      return 3
    },
    cardContentStyle () {
      const targetWidth = this.targetColumn > 1 ? 403 : 318
      let targetWidthString = ''
      const totalMarginRight = `${30 * this.targetColumn}px`
      if (this.targetColumn === 1) {
        targetWidthString = `calc(100% / ${this.targetColumn})`
      } else if (this.filterDataset.length <= this.targetColumn) {
        targetWidthString = `calc((100% - ${totalMarginRight}) / ${this.targetColumn})`
      } else {
        targetWidthString = `calc((100% - ${totalMarginRight}) / ${this.targetColumn} + ${targetWidth / this.targetColumn / 2}px)`
      }

      return {
        width: targetWidthString,
        minWidth: '318px'
      }
    }
  },
  methods: {
    onScroll () {
      if (this.$refs.scrollPanel.scrollLeft + this.$refs.scrollPanel.clientWidth + 20 >= this.$refs.scrollPanel.scrollWidth) { // reach right edge
        this.loadPosts()
      }
    },
    loadPosts () {
      if (this.onLazyLoading || this.slideCount >= this.filterDataset.length) return
      this.onLazyLoading = true

      setTimeout(() => {
        this.slideCount += 10
        this.onLazyLoading = false
      }, 500)
    }
  }
}
</script>

<style lang="scss">
.cases-container-lazyload {
  position: relative;
  height: 425px;

  @include breakpoint(500px) {
    height: 389px;

    &::before {
      opacity: 0;
    }
  }

  &::before {
    position: absolute;
    content: '';
    pointer-events: none;
    top: 0;
    right: 0;
    width: 50px;
    height: 100%;
    background: linear-gradient(to right, rgba(#FFFFFF, 0) 0%, rgba(#FFFFFF, 0) 50%, rgba(#FFFFFF, 1) 100%);
  }

  .scroll-content {
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    white-space: nowrap;
    text-align: center;

      & > * {
        display: inline-block;
        vertical-align: top;
        height: 100%;
        box-sizing: border-box;

        &:not(:last-of-type) {
          margin-right: 30px;
        }
      }

      .case-content {
        text-align: left;

        .case-card {
          user-select: none;
          display: inline-block;
          vertical-align: top;
          width: 100%;
          height: 100%;
          box-sizing: border-box;

          .img-container {
            pointer-events: none;
          }

          .content {
            white-space: pre-wrap;
            ul li {
              font-size: 15px;
              font-family: $font-CuratorRegular;
            }
          }
        }
      }

      .logo-container-case-card-container > * {
        top: 50%;
        transform: translateY(-50%);
      }
  }
}
</style>
